import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import * as XLSX from 'xlsx';
import { ReferenzaFirestore } from '../core/models/firestore/referenza.model';

@Injectable({
  providedIn: 'root'
})
export class ExcelExportService {

  constructor(private logger: NGXLogger) {}

  /**
   * Esporta le referenze in formato Excel
   * @param referenze Array di referenze da esportare
   * @param fileName Nome del file (opzionale, se non fornito viene generato automaticamente)
   */
  exportReferenze(referenze: ReferenzaFirestore[], fileName?: string): void {
    if (!referenze || referenze.length === 0) {
      this.logger.warn('[EXCEL-EXPORT] Nessun dato da esportare');
      return;
    }

    try {
      // Prepara i dati per l'export con tutti i campi disponibili
      const excelData = referenze.map(ref => ({
        'ID': ref.id || '',
        'Titolo Breve': ref.titoloBreve || '',
        'Titolo Esteso': ref.titoloEsteso || '',
        'Cliente': ref.cliente || '',
        'Project Manager': ref.projectManager || '',
        'RTP': ref.rtp ? 'Sì' : 'No',
        'Capogruppo': ref.capogruppo ? 'Sì' : 'No',
        'In AQ': ref.inAq ? 'Sì' : 'No',
        'Data Fine': ref.dataFine || '',
        'Categorie Servizio': ref.categorieServizio?.join(', ') || '',
        'Tag': ref.tag?.join(', ') || '',
        'Categorie Tag': ref.categorieTag?.join(', ') || '',
        'Codice Commerciale': ref.codiceCommerciale || '',
        'Codice Certificato': ref.codiceCertificato || '',
        'Quota Cooprogetti': ref.quotaCooprogetti || '',
        'Importo Lavori': ref.importoLavori || '',
        'Importo Servizio': ref.importoServizio || '',
        'Tempistiche': ref.tempistiche || '',
        'Valore Dimensione': ref.valoreDimensione || '',
        'Data Creazione': ref.dataCreazione || '',
        'Data Modifica': ref.dataModifica || ''
      }));

      // Crea il workbook
      const worksheet = XLSX.utils.json_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Referenze');

      // Genera il nome del file se non fornito
      if (!fileName) {
        const now = new Date();
        const dateStr = now.toISOString().split('T')[0];
        const timeStr = now.toTimeString().split(' ')[0].replace(/:/g, '-');
        fileName = `referenze_${dateStr}_${timeStr}.xlsx`;
      }

      // Scarica il file
      XLSX.writeFile(workbook, fileName);

      this.logger.info('[EXCEL-EXPORT] ✅ File Excel esportato con successo:', fileName, 'Righe:', excelData.length);
    } catch (error) {
      this.logger.error('[EXCEL-EXPORT] ❌ Errore durante l\'esportazione Excel:', error);
      throw error;
    }
  }
}

